import { useState, useEffect } from 'react';
import { queryPageAuthority } from '@gp/services/global';

export default function AuthChecker(options: {
  studioPageKey: string;
  studioId: string;
}) {
  const { studioPageKey = '', studioId = '' } = options || {};
  const [isLoading, setIsLoading] = useState(true);
  // 当前页面是否有edit权限
  const [editable, setEditable] = useState(false);
  // 当前页面有访问权限的模块
  const [accessableModules, setAccessableModules] = useState<string[]>([]);
  const [resOriginalData, setResOriginalData] = useState<{[keyName: string]: boolean} | null>(null);

  const updateAccessData = async () => {
    setIsLoading(true);
    try {
      const res = await queryPageAuthority({
        assort: studioPageKey,
        id: studioId,
      });
      setResOriginalData(res);
      const accessMap: {
        [key: string]: boolean;
      } = res || {};
      const accessableModules = Object.entries(accessMap)?.reduce<string[]>(
        (current, next) => {
          const [moduleName, moduleAccessable] = next || [];
          if (!moduleName || !moduleAccessable) return current;
          return [...current, moduleName];
        },
        [],
      );
      setEditable(!!accessMap?.edit);
      setAccessableModules(accessableModules || []);
    } catch (exception) {
      setEditable(false);
      setAccessableModules([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    updateAccessData();
  }, []);

  return {
    isLoading,
    editable,
    accessableModules,
    resOriginalData,
  };
}
